var $c70fdb737550c530$exports = {};
$c70fdb737550c530$exports = {
    "alert": `Figyelmeztet\xe9s`,
    "dismiss": `Elutas\xedt\xe1s`
};


export {$c70fdb737550c530$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
